var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSouColaboradorAllied(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2567_1384)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 125,
    r: 125,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.087 136.902C152.823 138.913 142.472 140.244 138.074 140.489H157.911C157.388 139.252 156.779 138.052 156.087 136.902Z",
    fill: "#EFC38E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.337 145.014H94.3018L70.3887 194.662C71.5233 195.664 72.729 196.584 73.9962 197.413L70.4147 204.953C75.5602 206.366 80.9809 206.447 86.1662 205.187L87.4849 202.111C88.8 202.239 90.1214 202.295 91.4427 202.276L100.808 185.136L97.9928 199.364C99.2581 199.987 100.559 200.536 101.89 201.005L100.852 205.184C105.541 206.524 110.511 206.524 115.2 205.184L115.64 203.216C116.898 203.208 118.163 203.158 119.437 203.053L129.756 161.309L132.875 161.777L154.579 160.035C159.041 156.387 160.985 151.852 159.337 145.014Z",
    fill: "#EFC38E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.121 90.7993C132.078 91.4823 131.939 92.1559 131.711 92.8008L134.206 90.4614C133.528 90.6606 132.827 90.7742 132.121 90.7993Z",
    fill: "#2480E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.051 112.835V124.948C142.727 124.844 143.402 124.74 144.078 124.61C143.717 120.637 143.038 116.7 142.051 112.835Z",
    fill: "#2480E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.897 130.796L123.726 129.627C123.362 129.315 122.998 128.977 122.66 128.639C123.495 125.026 125.727 126.378 126.897 130.796Z",
    fill: "#2480E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.672 86.0891V118.944C102.671 120.143 102.194 121.293 101.346 122.141C100.498 122.989 99.3485 123.466 98.1491 123.466H96.4336C97.6329 123.466 98.7828 122.989 99.6308 122.141C100.479 121.293 100.956 120.143 100.956 118.944V86.0891C100.956 84.8898 100.479 83.7398 99.6308 82.8919C98.7828 82.0439 97.6329 81.5671 96.4336 81.5664H98.1491C99.3485 81.5671 100.498 82.0439 101.346 82.8919C102.194 83.7398 102.671 84.8898 102.672 86.0891Z",
    fill: "#2480E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.272 139.348H82.8929C82.3509 139.353 81.8263 139.156 81.4215 138.797C81.0167 138.435 80.761 137.937 80.7041 137.398L79.28 123.495H77.5645L79.4619 140.806H87.7016C87.7052 140.616 87.6709 140.427 87.6007 140.251C87.5306 140.074 87.4258 139.913 87.2928 139.777C87.1597 139.642 87.0009 139.534 86.8256 139.46C86.6504 139.386 86.4621 139.348 86.272 139.348Z",
    fill: "#2480E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144 81.4104C144.306 81.0416 144.472 80.5754 144.465 80.0956C144.458 79.616 144.282 79.1544 143.964 78.7939C143.648 78.4336 143.213 78.198 142.738 78.1296C142.264 78.0613 141.779 78.1648 141.375 78.4213C141.595 78.0258 141.674 77.5678 141.602 77.1211C141.531 76.6744 141.31 76.2651 140.976 75.9591C140.643 75.6529 140.217 75.4678 139.766 75.4335C139.314 75.3992 138.866 75.5178 138.489 75.77C139.701 73.588 136.227 71.7234 134.933 73.8206C134.132 76.1885 133.132 78.4841 131.943 80.6826C135.27 76.0313 137.506 80.9686 137.298 83.8797C137.324 84.4516 137.61 84.6075 138.545 83.9317C140.469 82.5281 141.847 85.8032 138.26 87.4147C137.154 89.5409 136.831 91.9887 137.35 94.3287C137.324 93.9648 136.908 86.7129 145.096 85.2053C145.52 85.1155 145.9 84.8834 146.174 84.5477C146.447 84.2122 146.598 83.793 146.6 83.3599C146.603 83.0436 146.532 82.731 146.391 82.4475C146.252 82.1639 146.046 81.9174 145.793 81.7277C145.54 81.5379 145.246 81.4103 144.934 81.3553C144.622 81.3002 144.302 81.319 144 81.4104Z",
    fill: "#2480E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.787 102.776C135.787 103.024 135.689 103.263 135.514 103.438C135.337 103.613 135.099 103.712 134.852 103.712C134.604 103.712 134.366 103.613 134.19 103.438C134.015 103.263 133.916 103.024 133.916 102.776C133.916 102.528 134.015 102.29 134.19 102.115C134.366 101.939 134.604 101.841 134.852 101.841C135.099 101.841 135.337 101.939 135.514 102.115C135.689 102.29 135.787 102.528 135.787 102.776Z",
    fill: "#2480E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.793 111.432C126.793 111.68 126.695 111.918 126.52 112.093C126.343 112.269 126.105 112.368 125.857 112.368C125.61 112.368 125.372 112.269 125.195 112.093C125.02 111.918 124.922 111.68 124.922 111.432C124.922 111.184 125.02 110.946 125.195 110.77C125.372 110.595 125.61 110.496 125.857 110.496C126.105 110.496 126.343 110.595 126.52 110.77C126.695 110.946 126.793 111.184 126.793 111.432Z",
    fill: "#2480E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.786 121.231C133.786 121.479 133.687 121.717 133.512 121.893C133.335 122.068 133.097 122.167 132.85 122.167C132.602 122.167 132.364 122.068 132.188 121.893C132.013 121.717 131.914 121.479 131.914 121.231C131.914 120.983 132.013 120.745 132.188 120.569C132.364 120.394 132.602 120.295 132.85 120.295C133.097 120.295 133.335 120.394 133.512 120.569C133.687 120.745 133.786 120.983 133.786 121.231Z",
    fill: "#2480E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.195 124.168H175.837C175.506 124.168 175.189 124.3 174.955 124.534C174.721 124.768 174.59 125.085 174.59 125.416V139.244C174.59 139.575 174.721 139.892 174.955 140.126C175.189 140.36 175.506 140.492 175.837 140.492H185.195C185.525 140.487 185.839 140.353 186.072 140.121C186.306 139.888 186.438 139.574 186.442 139.244V125.41C186.441 125.081 186.308 124.764 186.076 124.532C185.842 124.299 185.525 124.168 185.195 124.168Z",
    fill: "#2480E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.827 58.377L171.169 61.834C170.943 61.895 170.736 62.0144 170.571 62.1802C170.405 62.3462 170.286 62.5527 170.225 62.7793C170.165 63.0057 170.165 63.2441 170.225 63.4705C170.286 63.697 170.405 63.9035 170.571 64.0693L181.956 75.3501C182.121 75.5158 182.328 75.6349 182.555 75.6957C182.781 75.7564 183.02 75.7564 183.246 75.6958C183.473 75.6353 183.679 75.5162 183.845 75.3507C184.01 75.185 184.129 74.9787 184.191 74.7523L187.57 61.86L183.827 58.377Z",
    fill: "#2480E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.596 53.0887C192.369 52.8648 192.1 52.6879 191.804 52.568C191.51 52.4482 191.194 52.3879 190.875 52.3902C190.556 52.3927 190.24 52.4579 189.948 52.5821C189.654 52.7065 189.388 52.8875 189.165 53.1147L183.889 58.4432L187.446 61.7442L192.618 56.5197C193.064 56.0591 193.313 55.4415 193.309 54.7997C193.305 54.158 193.048 53.5434 192.596 53.0887Z",
    fill: "#2480E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9696 35.6676C80.9688 35.9965 80.8704 36.3179 80.6871 36.5911C80.5037 36.8641 80.2435 37.0767 79.9392 37.2019C79.6351 37.3271 79.3006 37.3592 78.978 37.2944C78.6556 37.2295 78.3595 37.0704 78.1274 36.8374C77.8952 36.6043 77.7375 36.3076 77.6739 35.9849C77.6104 35.6622 77.6439 35.3278 77.7703 35.0241C77.8969 34.7204 78.1104 34.461 78.3843 34.2787C78.6582 34.0965 78.9799 33.9995 79.3088 34C79.5276 33.9996 79.7443 34.0425 79.9464 34.1263C80.1485 34.2101 80.3321 34.333 80.4864 34.488C80.6409 34.6431 80.763 34.8271 80.8459 35.0296C80.9288 35.2321 80.9708 35.4489 80.9696 35.6676Z",
    fill: "#2480E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.2 205.187C110.511 206.526 105.541 206.526 100.852 205.187C96.4596 206.461 87.8301 212.595 87.8301 212.595H116.864C116.589 210.071 116.031 207.587 115.2 205.187Z",
    fill: "#2480E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1666 205.187C80.9814 206.447 75.5607 206.366 70.4151 204.953C65.7043 206.498 61.4157 209.113 57.8867 212.595H87.8042C87.4395 210.089 86.8922 207.613 86.1666 205.187Z",
    fill: "#2480E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.023 161.364L132.877 161.78L129.758 161.312L130.408 158.687L138.023 161.364Z",
    fill: "#2480E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.035 140.491H25.9684C25.3686 140.491 24.7935 140.729 24.3694 141.154C23.9453 141.578 23.707 142.154 23.707 142.753C23.707 143.352 23.9453 143.928 24.3694 144.352C24.7935 144.776 25.3686 145.014 25.9684 145.014H53.6614L40.9141 215.584C40.8926 215.713 40.8839 215.844 40.8881 215.974H45.4628L58.2731 145.014H195.778L208.592 216H213.167C213.141 215.87 213.141 215.74 213.115 215.589L200.369 145.02H228.035C228.634 145.02 229.21 144.782 229.634 144.358C230.058 143.933 230.296 143.357 230.296 142.758C230.296 142.159 230.058 141.583 229.634 141.159C229.21 140.735 228.634 140.497 228.035 140.497V140.491Z",
    fill: "#2480E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9676 35.6676C80.9668 35.9965 80.8685 36.3179 80.6852 36.5911C80.5017 36.8641 80.2415 37.0767 79.9372 37.2019C79.6331 37.3271 79.2986 37.3592 78.9761 37.2944C78.6536 37.2295 78.3576 37.0704 78.1254 36.8374C77.8933 36.6043 77.7355 36.3076 77.6719 35.9849C77.6084 35.6622 77.642 35.3278 77.7684 35.0241C77.8949 34.7204 78.1085 34.461 78.3823 34.2787C78.6562 34.0965 78.978 33.9995 79.3069 34C79.5256 33.9996 79.7423 34.0425 79.9445 34.1263C80.1466 34.2101 80.3301 34.333 80.4845 34.488C80.6389 34.6431 80.7611 34.8271 80.844 35.0296C80.9269 35.2321 80.9689 35.4489 80.9676 35.6676Z",
    stroke: "#033B71",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.596 53.0887C192.369 52.8648 192.1 52.6879 191.804 52.568C191.51 52.4482 191.194 52.3879 190.875 52.3902C190.556 52.3927 190.24 52.4579 189.948 52.5821C189.654 52.7065 189.388 52.8875 189.165 53.1147L183.889 58.4432L187.446 61.7442L192.618 56.5197C193.064 56.0591 193.313 55.4415 193.309 54.7997C193.305 54.158 193.048 53.5434 192.596 53.0887Z",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.035 140.492H25.9684C25.3686 140.492 24.7935 140.73 24.3694 141.154C23.9453 141.578 23.707 142.154 23.707 142.753C23.707 143.352 23.9453 143.928 24.3694 144.352C24.7935 144.776 25.3686 145.014 25.9684 145.014H53.6614L40.9141 215.584C40.8926 215.713 40.8839 215.844 40.8881 215.974H45.4628L58.2731 145.014H195.778L208.592 216H213.167C213.141 215.87 213.141 215.74 213.115 215.59L200.369 145.02H228.035C228.634 145.02 229.21 144.782 229.634 144.358C230.058 143.934 230.296 143.358 230.296 142.759C230.296 142.159 230.058 141.583 229.634 141.159C229.21 140.735 228.634 140.497 228.035 140.497V140.492Z",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.996 136.957C119.917 138.418 118.433 139.531 116.729 140.159C115.025 140.787 113.174 140.903 111.404 140.492",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2069 132.59C62.2069 132.59 49.5677 131.421 47.8262 140.492",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6976 134.617C66.3077 134.409 65.9931 134.207 65.6839 134.019C64.2147 133.132 63.6825 132.538 62.3829 131.68C61.133 130.851 59.9742 129.893 58.9258 128.821C56.0393 125.859 57.0024 125.338 60.2515 127.287C60.2712 127.29 60.2895 127.3 60.3034 127.313C62.4608 128.62 64.7108 129.768 67.0355 130.746",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6852 134.019C62.8453 132.764 59.9194 131.712 56.9298 130.873C54.4099 130.164 54.8504 129.597 55.2663 129.521C56.8018 129.405 58.3456 129.465 59.867 129.703",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.229 139.348C65.6572 139.27 65.1113 139.234 64.6435 139.218C60.1495 139.054 61.7337 138.054 63.2919 137.606C64.099 137.375 65.4232 137.112 66.4889 136.749",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.441 164.015L170.849 216",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.475 126.274L159.311 125.39",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.642 203.219L115.201 205.187",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.826 205.187L101.89 201.008",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4936 202.094L86.168 205.187",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3906 204.979L73.9981 197.413",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.828 185.069L91.4446 202.276C83.7083 202.541 76.1673 199.815 70.3906 194.662L94.3038 145.014",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.979 203.115L121.57 157.647C121.709 156.982 121.979 156.353 122.364 155.793C122.749 155.235 123.241 154.757 123.811 154.389C124.382 154.021 125.02 153.771 125.688 153.652C126.357 153.533 127.042 153.548 127.704 153.696C135.774 155.5 150.946 157.158 152.472 145.074",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1758 128.907L107.638 124.119C112.498 116.732 118.271 99.6204 126.638 97.2427C128.01 96.8928 129.259 96.1736 130.251 95.1633",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.122 90.799C132.811 90.7744 133.495 90.6734 134.162 90.498L131.699 92.8005",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.762 95.3684C138.164 96.1077 138.833 96.6654 139.633 96.928C143.791 98.4799 147.644 100.749 151.018 103.631C154.868 107.164 158.268 120.106 159.751 128.636C160.11 130.642 159.698 132.707 158.6 134.423C157.501 136.138 155.796 137.377 153.825 137.89C148.683 139.318 143.402 140.189 138.074 140.489",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.041 124.012C139.497 125.468 131.848 126.319 124.168 126.56",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.053 124.59C143.715 120.614 143.036 116.675 142.025 112.815V124.953",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6582 128.171C85.0263 131.802 85.8669 136.22 84.9975 140.466",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.786 130.094C112.784 130.978 107.664 132.435 104.909 133.318C103.609 133.728 105.922 135.215 113.772 132.954",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.174 132.122C113.277 133.318 110.523 134.694 108.026 136.021C106.856 136.643 107.922 137.996 114.836 135.137",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.72 134.02C114.626 135.371 113.678 136.682 111.847 138.646C110.995 139.561 112.56 140.117 118.345 136.047C119.412 135.296 119.987 136.119 121.386 137.295C123.237 138.847 124.48 140.648 125.831 140.466",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.1 127.963C117.021 123.175 118.372 122.902 119.1 124.116C120.334 126.108 121.828 127.925 123.542 129.521",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.66 128.639C123.309 125.821 124.812 126.023 125.997 128.346C127.365 131.033 128.612 140.492 125.753 140.492",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.802 130.761C123.744 129.62 118.838 127.625 117.514 127.625C117.02 127.625 111.38 129.267 108.651 130.017C106.857 130.512 106.001 131.339 108.91 131.238C110.132 131.196 111.484 131.03 112.705 130.874",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.101 110.499C119.973 116.003 120.044 121.686 121.309 127.16",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4617 140.466H66.1016L67.7651 123.492H77.5903L79.4617 140.466Z",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.939 80.7085C133.126 78.5088 134.126 76.2134 134.929 73.8464C135.176 73.4828 135.533 73.2077 135.948 73.0612C136.362 72.9147 136.812 72.9045 137.234 73.0323C137.655 73.1599 138.023 73.4188 138.287 73.771C138.55 74.1232 138.693 74.5504 138.698 74.9901C138.695 75.2716 138.624 75.5481 138.49 75.7959C138.866 75.5436 139.314 75.4251 139.766 75.4593C140.217 75.4937 140.643 75.6788 140.977 75.9849C141.309 76.2911 141.531 76.7004 141.602 77.1471C141.674 77.5936 141.595 78.0516 141.375 78.4471C141.78 78.1906 142.264 78.0872 142.739 78.1554C143.213 78.2238 143.648 78.4594 143.964 78.8199C144.282 79.1802 144.458 79.6419 144.465 80.1216C144.472 80.6012 144.306 81.0674 144 81.4363C144.25 81.3558 144.513 81.3263 144.776 81.3494C145.037 81.3726 145.291 81.448 145.523 81.5713C145.755 81.6944 145.959 81.8629 146.125 82.0666C146.29 82.2703 146.413 82.5054 146.487 82.7575C146.56 83.0096 146.581 83.2739 146.551 83.5347C146.52 83.7954 146.438 84.0474 146.308 84.2756C146.178 84.5038 146.004 84.7037 145.795 84.8634C145.587 85.0231 145.349 85.1392 145.094 85.2052C142.881 85.444 140.843 86.5235 139.401 88.2213C137.96 89.9189 137.226 92.105 137.349 94.3286",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.762 95.3686L137.268 99.2675L133.292 96.1224L128.795 98.3837L130.251 95.1606",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.292 96.1223C130.017 104.388 128.847 114.759 128.795 126.3",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.445 128.613C187.432 128.613 188.377 129.004 189.073 129.702C189.771 130.398 190.162 131.344 190.162 132.33C190.162 133.316 189.771 134.262 189.073 134.958C188.377 135.656 187.432 136.047 186.445 136.047",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.522 94.1209C220.522 94.5733 220.388 95.0156 220.136 95.3916C219.886 95.7679 219.527 96.061 219.11 96.2341C218.691 96.4073 218.232 96.4526 217.788 96.3643C217.344 96.2761 216.937 96.0581 216.617 95.7383C216.297 95.4185 216.08 95.0108 215.991 94.5671C215.903 94.1235 215.948 93.6635 216.121 93.2456C216.294 92.8277 216.587 92.4703 216.963 92.219C217.34 91.9677 217.782 91.8335 218.234 91.8335C218.535 91.8318 218.834 91.8896 219.111 92.004C219.39 92.1182 219.643 92.2868 219.855 92.4995C220.069 92.7122 220.237 92.965 220.351 93.2434C220.466 93.5218 220.523 93.8201 220.522 94.1209Z",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.146 133.89L218.236 96.4082",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.236 91.8333L194.791 65.5288",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.983 63.7355L188.006 61.1882",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.647 72.0793C178.226 72.4083 177.727 72.6243 177.197 72.7069C176.669 72.7895 176.129 72.7359 175.627 72.5511C175.123 72.3664 174.677 72.0567 174.328 71.6512C173.978 71.2457 173.739 70.7579 173.631 70.2338C173.539 69.7912 173.546 69.3342 173.648 68.8942C173.752 68.4543 173.949 68.0422 174.228 67.6865",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.18 64.4634C195.18 64.7977 195.081 65.1242 194.895 65.402C194.709 65.6799 194.445 65.8965 194.137 66.0244C193.828 66.1523 193.489 66.1857 193.16 66.1205C192.833 66.0553 192.531 65.8944 192.296 65.6581C192.059 65.4219 191.898 65.1208 191.833 64.793C191.768 64.4654 191.802 64.1257 191.929 63.8169C192.058 63.5082 192.274 63.2443 192.552 63.0586C192.829 62.873 193.156 62.7739 193.49 62.7739C193.936 62.7797 194.363 62.9594 194.679 63.275C194.994 63.5906 195.174 64.0172 195.18 64.4634Z",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.809 135.579C203.809 135.913 203.71 136.24 203.524 136.518C203.338 136.795 203.074 137.013 202.766 137.14C202.457 137.267 202.118 137.302 201.789 137.236C201.462 137.172 201.16 137.01 200.925 136.773C200.688 136.538 200.527 136.236 200.462 135.909C200.397 135.581 200.431 135.241 200.558 134.932C200.685 134.624 200.903 134.36 201.181 134.174C201.458 133.988 201.785 133.89 202.119 133.89C202.341 133.89 202.561 133.932 202.766 134.017C202.971 134.102 203.157 134.226 203.315 134.384C203.472 134.541 203.596 134.727 203.681 134.932C203.766 135.137 203.809 135.358 203.809 135.579Z",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.875 167.576L129.756 216",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9564 58.641H66.4648V43.1494H81.9564V58.641Z",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.209 46.6843L78.7317 37.145",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6333 170.265H17.8066",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.707 176.18V164.353",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.991 162.767C221.052 163.446 220.912 164.127 220.586 164.725C220.26 165.324 219.764 165.812 219.16 166.129C218.557 166.446 217.875 166.576 217.197 166.505C216.519 166.432 215.879 166.161 215.355 165.725C214.832 165.289 214.449 164.707 214.256 164.055C214.063 163.401 214.069 162.704 214.271 162.055C214.474 161.403 214.865 160.827 215.394 160.399C215.925 159.971 216.569 159.71 217.248 159.648C217.699 159.602 218.155 159.647 218.59 159.779C219.024 159.912 219.426 160.13 219.775 160.421C220.124 160.711 220.411 161.068 220.62 161.472C220.828 161.874 220.954 162.314 220.991 162.767Z",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.96289 216H254.963",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.832 212.595H116.866",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8613 212.595H87.7788",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8307 212.554C87.5553 210.043 86.9977 207.571 86.1686 205.186C80.9833 206.446 75.5626 206.365 70.4171 204.952C64.2503 207.046 58.8177 210.872 54.7695 215.974C66.7781 215.974 74.7578 216 83.8032 215.974",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.202 205.187C110.513 206.526 105.543 206.526 100.854 205.187C94.3803 207.064 86.0969 213.68 83.8027 215.974C97.5268 215.974 106.156 215.844 116.943 215.844C117.038 212.213 116.447 208.598 115.202 205.187Z",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.756 161.312L130.406 158.687L138.021 161.364",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.756 161.312L132.875 161.779L160.943 159.487",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.562 159.752L155.725 159.102",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.918 201.314L104.908 164.431",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.898 126.144C133.238 129.601 133.836 134.383 132.64 140.492",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.326 167.056L132.875 167.576L161.33 165.211C161.928 165.164 162.495 164.93 162.952 164.543C163.409 164.156 163.734 163.635 163.877 163.053L176.172 103.452C176.306 102.813 176.299 102.151 176.151 101.515C176.005 100.878 175.722 100.28 175.321 99.7637C174.92 99.2471 174.412 98.8237 173.832 98.5226C173.252 98.2215 172.613 98.05 171.961 98.0197L138.645 96.4082",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.542 144.234C114.88 144.747 112.432 146.043 110.51 147.955C108.589 149.868 107.281 152.31 106.755 154.969L98 199.365C104.678 202.525 112.093 203.803 119.444 203.058C119.444 202.93 127.404 170.826 129.763 161.314",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4332 81.5664C97.6326 81.5671 98.7824 82.0439 99.6304 82.8919C100.478 83.7399 100.955 84.8899 100.956 86.0891V118.97C100.956 120.169 100.48 121.32 99.6314 122.169C98.7834 123.017 97.633 123.494 96.4332 123.495H51.4921C50.2916 123.495 49.1401 123.019 48.29 122.171C47.4401 121.323 46.9607 120.173 46.957 118.972V86.0891C46.9559 85.4955 47.072 84.9077 47.2984 84.359C47.5248 83.8103 47.8571 83.3116 48.2764 82.8916C48.6957 82.4715 49.1938 82.1382 49.7421 81.9109C50.2902 81.6835 50.878 81.5664 51.4715 81.5664H96.4332Z",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.672 86.0891V118.944C102.671 120.143 102.194 121.293 101.346 122.141C100.498 122.989 99.3485 123.466 98.1491 123.466H96.4336C97.6329 123.466 98.7828 122.989 99.6308 122.141C100.479 121.293 100.956 120.143 100.956 118.944V86.0891C100.956 84.8899 100.479 83.7399 99.6308 82.8919C98.7828 82.0439 97.6329 81.5671 96.4336 81.5664H98.1491C99.3485 81.5671 100.498 82.0439 101.346 82.8919C102.194 83.7399 102.671 84.8899 102.672 86.0891Z",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.542 83.9591C140.457 82.5473 141.825 85.81 138.256 87.4421C137.759 87.6692 136.229 92.6666 137.762 95.3767C135.313 96.1824 132.356 96.6626 130.25 95.1687C131.363 93.9739 132.023 92.4288 132.12 90.7992C125.362 90.9032 131.809 80.6881 131.938 80.6881C135.242 76.0683 137.469 80.9289 137.297 83.8237C137.246 84.6787 137.846 84.4694 138.542 83.9591Z",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.719 159.953C156.445 158.659 157.824 156.957 158.731 154.999C159.64 153.042 160.046 150.889 159.917 148.735C159.823 147.501 159.642 146.278 159.38 145.077",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.086 136.902C156.792 138.052 157.406 139.252 157.926 140.49",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.448 139.244C186.448 139.575 186.317 139.892 186.083 140.126C185.849 140.36 185.532 140.492 185.201 140.492H175.843C175.512 140.492 175.195 140.36 174.961 140.126C174.727 139.892 174.596 139.575 174.596 139.244V125.41C174.596 125.079 174.727 124.762 174.961 124.528C175.195 124.294 175.512 124.163 175.843 124.163H185.195C185.359 124.163 185.521 124.195 185.673 124.258C185.825 124.321 185.961 124.412 186.078 124.528C186.194 124.644 186.286 124.782 186.348 124.933C186.41 125.085 186.443 125.246 186.443 125.41L186.448 139.244Z",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.894 137.242C213.996 137.245 214.093 137.283 214.167 137.349C214.24 137.415 214.281 137.504 214.284 137.598V140.133C214.281 140.227 214.24 140.316 214.167 140.382C214.093 140.448 213.996 140.486 213.894 140.489H190.37C190.268 140.486 190.171 140.448 190.097 140.382C190.024 140.316 189.983 140.227 189.98 140.133V137.598C189.983 137.504 190.024 137.415 190.097 137.349C190.171 137.283 190.268 137.245 190.37 137.242H213.894Z",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.875 167.576V161.78",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.825 58.377L171.167 61.834C170.941 61.895 170.735 62.0144 170.569 62.1802C170.403 62.3462 170.284 62.5527 170.223 62.7793C170.163 63.0057 170.163 63.2441 170.223 63.4705C170.284 63.697 170.403 63.9035 170.569 64.0693L181.954 75.3501C182.119 75.5158 182.326 75.6349 182.553 75.6957C182.779 75.7564 183.018 75.7564 183.244 75.6958C183.471 75.6353 183.677 75.5162 183.843 75.3507C184.009 75.185 184.128 74.9787 184.189 74.7523L187.568 61.86L183.825 58.377Z",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2567_1384"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSouColaboradorAllied);
export default __webpack_public_path__ + "static/media/SouColaboradorAllied.e649affdb08d35430566a398fe2381a1.svg";
export { ForwardRef as ReactComponent };